import { Component, ElementRef, Input, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { CsrdResultsDto, ExtraIndicatorsUserInputDto, GprMaterialsV1Service, HnnResultsDto, QciResultsDto, WlcResultsDto } from '../../core/services/GPRMV1Service.Generated';
import { DataSetSettingEnum } from '../../shared/enums/data-set-setting.enum';
import { environment } from '../../../environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { AppService } from '../../core/services/app.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { FeatureManagementService } from '../../core/services/feature-management.service';
import { NgxEchartsDirective } from 'ngx-echarts';
import { ECharts } from 'echarts';
import { EnergyTypeEnum } from '../../shared/enums/energy-type.enum';
import wlc from '../../../assets/json-data/wlc.json';
import { ModulesEnum } from '../../shared/enums/modules.enum';
import { noIndicatorSelected } from '../../shared/utils/indicator-utils';

@Component({
    selector: 'app-print-extra-indicator',
    templateUrl: './print-extra-indicator.component.html',
    styleUrls: ['./print-extra-indicator.component.scss', '../print-page.component.scss'],
    standalone: false
})
export class PrintExtraIndicatorComponent implements OnChanges {

    @ViewChild('content', { static: false }) contentElement!: ElementRef;

    @Input() qciResultsDto: QciResultsDto | null = null;
    @Input() hnnResultsDto: HnnResultsDto | null = null;
    @Input() csrdResultsDto: CsrdResultsDto | null = null;
    @Input() wlcResultsDto: WlcResultsDto | null = null;
    @Input() mpg: number;
    @Input() parisProofIndicator: number;
    
    @Input() selectedDataSet: number;
    @Input() totalUsedProducts: number
    @Input() constructionStoredCarbon: number
    dataSetSetting = DataSetSettingEnum;
    uploadsImageBaseUrl: string = environment.uploadsBaseUrl;

    // Show Hide Text Area Data
    showFullText: boolean = false;
    isContentTruncated: boolean = false;
    isTotalValueHigherThanLimitValue = true;
    isOrangeHigherThanLimit = false;
    isBlueHigherThanLimit = false;

    totalOrangeWidth: number = 0;
    totalBlueWidth: number = 0;
    totalLimitWidth: number = 0;
    orangePartitionWidth: number = 0;
    bluePartitionWidth: number = 0;

    maxLines: number = 3; // Set your count of lines here
    maxEmission: number = 0;
    urlId: string;

    //// Bar CHart Data

    limitValue: number;
    qci_biogen: number;
    qci_gwp_material: number;
    qci_energy: number;
    totalValue: number;

    extraIndicatorsUserInputDto: ExtraIndicatorsUserInputDto;
    isShowDismountabilityReuseUI: boolean = false;
    isWlcIndicatorEnabled: boolean;
    heatSupplyTypeValue: string = '';

    showBlueDot = {
        dismountability: false,
        originMaterials: false,
        futureMaterials: false
    };

    maxValue: number;

    materialEmissions: any[] = (wlc as any).materialEmissions;
    operationEmissions: any[] = (wlc as any).operationEmissions;

    wlc_energiegebruik_elektriciteitValue: number = 0;
    wlc_energiegebruik_aardgasValue: number = 0;
    wlc_energiegebruik_warmteValue: number = 0;
    wlc_energiegebruik_totalValue: number = 0;

    wlc_eigenopwekking_elektriciteitValue: number = 0;
    wlc_eigenopwekking_aardgasValue: number = 0;
    wlc_eigenopwekking_warmteValue: number = 0;
    wlc_eigenopwekking_totalValue: number = 0;
    wlc_limitValue: number = 0;

    wlc_emissies_per_bron_total: number = 0;

    wlc_total_toelevering_orange_width: number = 0;
    wlc_total_toelevering_blue_width: number = 0;
    wlc_total_toelevering_green_width: number = 0;
    toeleveringSegments: { value: number; color: string; }[];
    terugleveringSegments: { value: number; color: string; }[];
    wlcTotalScoreSegments: { value: number; color: string; }[];
    barMaxValue: number;
    wlc_mat_emissies_total: number;
    wlc_op_energy_emissies_total: number;
    wlc_total_score: number;
    private tooltipHideTimeout: any;
    activeTooltipRef: any = null;


    wlcScoreByGbo: number;
    isNegativeTotalScore: boolean;

    chartOptions = null;
    modulesEnum = ModulesEnum;
    public noIndicatorSelected = false;

    calculateMirrorWidth(value: number, max: number): number {
        return (Math.abs(value) / max) * 50;  
    }

    calculateOperationMirrorWidth(value: number, max: number): number {
        return (Math.abs(value) / max) * 50;  
    }


    private _destroySubscription: Subject<boolean> = new Subject();
    constructor(private _translate: TranslateService, private appService: AppService,
        private _gprMaterialsService: GprMaterialsV1Service, private _featureService: FeatureManagementService) {
            
    }
    
    ngOnChanges(changes: SimpleChanges): void {
        this.urlId = localStorage.getItem('urlId');
        if (changes.qciResultsDto) {
            this.loadQCIData();
        }

        if (changes.csrdResultsDto) {
            this.loadCSRDData();
        }
        if (changes.wlcResultsDto) {
            this.loadWLCData();
        }

        this.isWlcIndicatorEnabled = this.appService.getIsWlcIndicatorEnabled();

        this.getExtraIndicatorsUserInputs();

        this.getShowDismountabilityReuseUI();
        this.showBlueDot = {
            dismountability: this.hnnResultsDto?.hnnOverrideStats?.isDismountabilityOverridden,
            originMaterials: this.hnnResultsDto?.hnnOverrideStats?.isMassOrOriginMaterialsOverridden,
            futureMaterials: this.hnnResultsDto?.hnnOverrideStats?.isMassOrFutureMaterialsOverridden
        };

        // Recompute only when inputs change
        this.noIndicatorSelected = noIndicatorSelected(
            this.qciResultsDto,
            this.hnnResultsDto,
            this.csrdResultsDto,
            this.wlcResultsDto,
            (m) => this.isModuleAccessible(m),
            this.modulesEnum
        );
    }

    loadQCIData() {
        if (this.qciResultsDto) {
            this.qci_biogen = this.qciResultsDto.gwpBiogenic;
            this.qci_gwp_material = this.qciResultsDto.gwpMaterial;
            this.qci_energy = this.qciResultsDto.gwpEnergy;
            this.totalValue = this.qciResultsDto.gwpTotal;
            this.limitValue = this.qciResultsDto.gwpParisProofLimit;

            this.getOrangeWidth();
            this.getBlueWidth();
            this.getLightBlueWidth();
            this.checkHigherValue();
        }
    }

    getOrangeWidth() {

        this.totalOrangeWidth = this.limitValue < this.totalValue
            ? (this.qci_gwp_material / this.totalValue) * 100
            : (this.qci_gwp_material / this.limitValue) * 100;

        return this.totalOrangeWidth > 100 ? 100 : this.totalOrangeWidth;
    }

    getBlueWidth() {
        this.totalBlueWidth = this.limitValue < this.totalValue
            ? this.getOrangeWidth() + ((this.qci_energy / this.totalValue) * 100)
            : this.getOrangeWidth() + (this.qci_energy / this.limitValue) * 100;
        return this.totalBlueWidth < 0 ? 0 : this.totalBlueWidth;
    }

    getLightBlueWidth() {

        if (this.totalValue > this.limitValue) {
            this.isTotalValueHigherThanLimitValue = true;
            this.totalLimitWidth = (this.limitValue / this.totalValue) * 100;

        }
        else {
            this.isTotalValueHigherThanLimitValue = false;
            this.totalLimitWidth = this.totalBlueWidth;

        }
        return this.totalLimitWidth;
    }

    checkHigherValue() {
        if (this.totalValue > this.limitValue) {
            if (this.qci_gwp_material > this.limitValue) {
                this.isOrangeHigherThanLimit = true;
                this.orangePartitionWidth = this.totalOrangeWidth - this.totalLimitWidth;

            }
            else {
                this.isBlueHigherThanLimit = true;
                this.bluePartitionWidth = this.totalBlueWidth - this.totalLimitWidth;
            }
        }
        else {
            this.isOrangeHigherThanLimit = false;
            this.isBlueHigherThanLimit = false;
        }

    }
   
    
    loadCSRDData() {
        if (this.csrdResultsDto) {

            var emissionData = [
                { value: this.csrdResultsDto?.cat1Procurement },
                { value: this.csrdResultsDto?.cat11UseOfSoldProducts },
                { value: this.csrdResultsDto?.cat12EndOfLifeTreatment },
                { value: this.csrdResultsDto?.cat4Transport }
            ];

            this.maxEmission = Math.max(...emissionData.map(e => e.value));

        }
    }

    /* To get ExtraIndicator User Input data */
    getExtraIndicatorsUserInputs(): void {
       
        this._gprMaterialsService
            .getExtraIndicatorsUserInput(this.appService.getCalculationId())
            .pipe(takeUntil(this._destroySubscription))
            .subscribe({
                next: (resp: ExtraIndicatorsUserInputDto) => {
                    this.extraIndicatorsUserInputDto = resp;

                    const heatSupplyType = this.extraIndicatorsUserInputDto?.wlcAmpInput?.heatSupplyType?.value as string | undefined;

                    this.heatSupplyTypeValue = heatSupplyType
                        ? ((Object.values(EnergyTypeEnum) as string[]).includes(heatSupplyType)
                            ? (heatSupplyType as EnergyTypeEnum)
                            : EnergyTypeEnum[heatSupplyType as keyof typeof EnergyTypeEnum])
                        : undefined;  

                    this.showSankeyGraph();
                },
                error: (err) => {
                    console.error('Error fetching data:', err);
                },
            });
    }

    showSankeyGraph(): void {
        const round = (val?: number) => val != null ? Math.round(val) : 0;

        const allLinks = [

            { source: 'Nieuw', target: 'Gebruik', value: round(this.hnnResultsDto?.upstreamNewTotalPercentage), lineStyle: { color: '#9299AC' } },
            { source: 'Gerecycled', target: 'Gebruik', value: round(this.hnnResultsDto?.upstreamRecycledTotalPercentage), lineStyle: { color: '#FF7A00' } },
            { source: 'Bio-based', target: 'Gebruik', value: round(this.hnnResultsDto?.upstreamBioBasedTotalPercentage), lineStyle: { color: '#FFB500' } },
            { source: 'Hergebruikt', target: 'Gebruik', value: round(this.hnnResultsDto?.upstreamReusedTotalPercentage), lineStyle: { color: '#7FDCDB' } },

            { source: 'Gebruik', target: 'Storten', value: round(this.hnnResultsDto?.downstreamDumpTotalPercentage), lineStyle: { color: '#C8CBD5' } },
            { source: 'Gebruik', target: 'Verbranden', value: round(this.hnnResultsDto?.downstreamIncinerationTotalPercentage), lineStyle: { color: '#333E86' } },
            { source: 'Gebruik', target: 'Recyclen', value: round(this.hnnResultsDto?.downstreamRecyclableTotalPercentage), lineStyle: { color: '#FF7A00' } },
            { source: 'Gebruik', target: 'Hergebruiken', value: round(this.hnnResultsDto?.downstreamReusableTotalPercentage), lineStyle: { color: '#7FDCDB' } },
        ];

        const filteredLinks = allLinks.filter(link => link.value > 0);

        // Pre-calculate values per node for labeling
        const nodeValues: { [name: string]: number } = {};
        filteredLinks.forEach(link => {
            nodeValues[link.source] = (nodeValues[link.source] || 0) + link.value;
            nodeValues[link.target] = (nodeValues[link.target] || 0) + link.value;
        });

        if (filteredLinks.length > 0) {
            this.chartOptions = {
                backgroundColor: '#ffffff',
                tooltip: {
                    trigger: 'item',
                    formatter: ({ data, value }) => {
                        if (data.source && data.target) {
                            const total = filteredLinks
                                .filter(l => l.source === data.source)
                                .reduce((sum, l) => sum + l.value, 0);
                            const percent = total ? (value / total * 100).toFixed(0) + '%' : '';
                            return `${data.source} - ${data.target}<br>${percent}`;
                        }
                        return '';
                    }
                },

                series: [
                    {
                        type: 'sankey',
                        layout: 'none',
                        nodeGap: 30,
                        nodeWidth: 15,
                        lineStyle: { curveness: 0.5, width: 20 },
                        label: {
                            position: 'top',
                            formatter: function (params) {
                                const val = nodeValues[params.name];
                                return val != null || val != undefined ? `${params.name}   ${val}%` : '';
                            },
                            fontSize: 12,
                            color: '#2A2A2A',
                            fontFamily: 'Arial'
                        },
                        data: [
                            { name: 'Nieuw', x: 0, y: 0, itemStyle: { color: '#9299AC' } },
                            { name: 'Gerecycled', x: 0, y: 1, itemStyle: { color: '#FF7A00' } },
                            { name: 'Bio-based', x: 0, y: 2, itemStyle: { color: '#FFB500' } },
                            { name: 'Hergebruikt', x: 0, y: 3, itemStyle: { color: '#7FDCDB' } },

                            {
                                name: 'Gebruik',
                                x: 2,
                                y: 0,
                                itemStyle: { color: '#E3E9F2' },
                                label: {
                                    show: true,
                                    position: 'inside',
                                    formatter: () => `Totale massa\n${round(this.hnnResultsDto?.totalEpicProductWeight / 1000)} ton`,
                                    fontWeight: 'bold',
                                    fontSize: 14,
                                    color: '#000'
                                }
                            },

                            { name: 'Storten', x: 4, y: 0, itemStyle: { color: '#C8CBD5' } },
                            { name: 'Verbranden', x: 4, y: 1, itemStyle: { color: '#333E86' } },
                            { name: 'Recyclen', x: 4, y: 2, itemStyle: { color: '#FF7A00' } },
                            { name: 'Hergebruiken', x: 4, y: 3, itemStyle: { color: '#7FDCDB' } }
                        ],
                        links: filteredLinks
                    }
                ]
            };

        }
    }


    calculatePercentage(value: number, max: number) {
        return (value / max) * 100;
    }

    /**
    * get the ShowDismountabilityReuseUI feature flag
    */
    getShowDismountabilityReuseUI() {
        this._featureService.isShowDismountabilityReuseUI().subscribe(resp => this.isShowDismountabilityReuseUI = resp);
    }


    loadWLCData() {

        const data = this.wlcResultsDto;

        if (data != null) {
            this.wlc_energiegebruik_elektriciteitValue = data.electricityUsed;
            this.wlc_energiegebruik_aardgasValue = data.gasUsed;
            this.wlc_energiegebruik_warmteValue = data.heatUsed;
            this.wlc_energiegebruik_totalValue = data.totalEnergyUsed;

            this.wlc_eigenopwekking_elektriciteitValue = data?.electricityGenerated;
            this.wlc_eigenopwekking_aardgasValue = 0;
            this.wlc_eigenopwekking_warmteValue = 0;
            this.wlc_eigenopwekking_totalValue = data?.totalEnergyGenerated;


            this.toeleveringSegments = [
                { value: data.electricityUsed, color: '#333E86' },
                { value: data.gasUsed, color: '#00BBB9' },
                { value: data.heatUsed, color: '#FF7A00' }
            ];

            this.terugleveringSegments = [
                { value: Math.abs(data?.electricityGenerated), color: '#5F6CBE' }
            ];

            this.barMaxValue = Math.max(data.totalEnergyUsed, Math.abs(data?.totalEnergyGenerated));

            this.wlc_mat_emissies_total = data.totalMaterialEmission;
            this.wlc_op_energy_emissies_total = data.totalOperationalEnergyEmission;
            this.wlc_total_score = data.wlcScore;
            this.wlcScoreByGbo = data.wlcScoreByGbo;

            this.isNegativeTotalScore = data.wlcScore < 0 ? true : false;

            this.wlcTotalScoreSegments = [
                { value: data.wlcScore, color: '#FFB500' }
            ];

            const normalize = (c: string) => (c === 'D' ? 'D1' : c);

            this.materialEmissions.forEach(item => {
                const match = data.wlcMaterialPerPhase.find(x => normalize(x.code) === normalize(item.code));
                if (match) item.value = match.wlcMaterial;
            });

            this.operationEmissions[0].value = data.operationalEnergyUse;
            this.operationEmissions[1].value = data.outsideSystemExportedEnergy ?? 0;

            this.maxValue = this.getCombinedMaxEmission();
        }
    }

    getCombinedMaxEmission(): number {
        const allValues = [...this.materialEmissions, ...this.operationEmissions].map(e => Math.abs(e.value));
        return Math.max(...allValues);
    }

    isModuleAccessible(accessibleModule: string): boolean {
        return this.appService.isModuleAccessible(accessibleModule);
    }
}
